import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Subscription, interval } from 'rxjs';
import * as moment from 'moment';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-count-down-timer',
  templateUrl: './count-down-timer.component.html',
  styleUrls: ['./count-down-timer.component.scss']
})
export class CountDownTimer implements OnInit, OnDestroy {

  private subscription: Subscription;

  @Input() gameAlertObject: any; 
  @Output() closeMaintenanceBox: EventEmitter<any> = new EventEmitter<any>();

  public dateNow = new Date();
  dDay: any;
  fromTime: any;
  currentTime: any;
  toTime: any;
  milliSecondsInASecond = 1000;
  hoursInADay = 24;
  minutesInAnHour = 60;
  SecondsInAMinute  = 60;
  duration: any;

  public timeDifference: any;
  public secondsToDday: any = 0;
  public minutesToDday: any =0;
  public hoursToDday: any =0;
  public daysToDday: any = 0;
  daysToDay: number;

  constructor(
    private storage: LocalStorageService
  )
  {
  }

  private getTimeDifference () {
    const timeLeft = moment.duration(this.dDay.diff(moment())); 
    if (timeLeft.isValid()) {
      this.secondsToDday = timeLeft.seconds() < 0 ? 0 : timeLeft.seconds();
      this.minutesToDday = timeLeft.minutes();
      this.hoursToDday = timeLeft.hours();
      this.daysToDay = timeLeft.days();
    } else {
      this.secondsToDday = 0;
      this.minutesToDday = 0;
      this.hoursToDday = 0;
      this.daysToDay = 0;
    }

    if (timeLeft.seconds() < 0) {
      this.closeMaintenanceBox.emit();
      this.subscription.unsubscribe();
    } else if (timeLeft === undefined) {
      this.secondsToDday = 0;
      this.minutesToDday = 0;
      this.hoursToDday = 0;
      this.daysToDay = 0;
    }
    console.log('DATY ', this.daysToDay)
  }

  ngOnInit() {
    console.log("Game lis object ", this.gameAlertObject)
    const newTime = new Date()
    // this.currentTime = moment(newTime, 'DD/MM/YYYY hh:mm')
    // this.toTime = moment(this.gameAlertObject.toTime, 'DD/MM/YYYY hh:mm')
    // this.fromTime = moment(this.gameAlertObject.fromTime, 'DD/MM/YYYY hh:mm')
    this.currentTime = moment(newTime, 'YYYY/MM/DD hh:mm')
    this.toTime = moment(this.gameAlertObject.toTime, 'YYYY/MM/DD hh:mm')
    this.fromTime = moment(this.gameAlertObject.fromTime, 'YYYY/MM/DD hh:mm')
    if (this.toTime.isBefore(this.currentTime) && this.fromTime.isAfter(this.currentTime)) { 
      this.closeMaintenanceBox.emit();
    } else {
      this.dDay = this.toTime;
    }

    this.subscription = interval(1000)
      .subscribe(x => {  
        this.getTimeDifference()
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
